/**
 * Ölkələrin siyahısı (Azərbaycan dilində).
 * Həm vətəndaşlıq, həm də "xarici ölkə" seçimlərində istifadə olunur.
 * Siyahıda olmayan hal üçün OTHER seçilir və əl ilə yazmağa imkan verilir.
 */
export const COUNTRIES = [
  'Azərbaycan',
  'Türkiyə', 'Rusiya', 'Gürcüstan', 'İran', 'Ukrayna', 'Belarus', 'Qazaxıstan',
  'Özbəkistan', 'Türkmənistan', 'Qırğızıstan', 'Tacikistan', 'Moldova', 'Ermənistan',
  'ABŞ', 'Kanada', 'Meksika', 'Braziliya', 'Argentina', 'Çili', 'Kolumbiya', 'Peru',
  'Böyük Britaniya', 'İrlandiya', 'Almaniya', 'Fransa', 'İtaliya', 'İspaniya',
  'Portuqaliya', 'Hollandiya', 'Belçika', 'Lüksemburq', 'İsveçrə', 'Avstriya',
  'İsveç', 'Norveç', 'Danimarka', 'Finlandiya', 'İslandiya', 'Polşa', 'Çexiya',
  'Slovakiya', 'Macarıstan', 'Rumıniya', 'Bolqarıstan', 'Yunanıstan', 'Xorvatiya',
  'Serbiya', 'Sloveniya', 'Bosniya və Herseqovina', 'Monteneqro', 'Albaniya',
  'Şimali Makedoniya', 'Kosovo', 'Litva', 'Latviya', 'Estoniya', 'Kipr', 'Malta',
  'Çin', 'Yaponiya', 'Cənubi Koreya', 'Şimali Koreya', 'Monqolustan', 'Hindistan',
  'Pakistan', 'Banqladeş', 'Şri-Lanka', 'Nepal', 'Əfqanıstan', 'Vyetnam',
  'Tailand', 'Malayziya', 'Sinqapur', 'İndoneziya', 'Filippin', 'Myanma',
  'BƏƏ', 'Səudiyyə Ərəbistanı', 'Qətər', 'Küveyt', 'Bəhreyn', 'Oman', 'Yəmən',
  'İraq', 'Suriya', 'Livan', 'İordaniya', 'İsrail', 'Fələstin',
  'Misir', 'Mərakeş', 'Əlcəzair', 'Tunis', 'Liviya', 'Sudan',
  'Nigeriya', 'Keniya', 'Efiopiya', 'Qana', 'Tanzaniya', 'Uqanda',
  'Cənubi Afrika Respublikası', 'Seneqal', 'Kamerun', 'Kot-d’İvuar',
  'Avstraliya', 'Yeni Zelandiya',
];

/** Siyahıda olmayan ölkə üçün — əl ilə yazmağa imkan verir */
export const OTHER = '__other__';

export default COUNTRIES;
